/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

Essentals

*/

import $ from 'jquery';


/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

NPM Packages

*/

import 'lazysizes/plugins/print/ls.print'; // needs to be BEFORE the main script
import 'lazysizes';
import 'print-this';


/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

allink CORE (NPM package)

===

These modules provide core functionality.

Note: Should you need a customzied project specific version of one of
the following modules:

Head over to the 'allink-core-static' repo, comment out the module below,
download the latest version and place it in the ./modules folder.

*/

import 'allink-core-static/js/modules/ajax-form';
import 'allink-core-static/js/modules/bootstrap-select';
import 'allink-core-static/js/modules/btn-ajax-loader';
import 'allink-core-static/js/modules/datepicker';
import 'allink-core-static/js/modules/djangocms-tweaks';
import 'allink-core-static/js/modules/form';
import 'allink-core-static/js/modules/form-modal';
import 'allink-core-static/js/modules/form-validation';
import 'allink-core-static/js/modules/full-height';
import 'allink-core-static/js/modules/image-modal';
import 'allink-core-static/js/modules/masonry';
import 'allink-core-static/js/modules/seo';
import 'allink-core-static/js/modules/site-overlay';
import 'allink-core-static/js/modules/softpage';
import 'allink-core-static/js/modules/table';
import 'allink-core-static/js/modules/tingle';
import 'allink-core-static/js/modules/video';
import 'allink-core-static/js/modules/viewport-dimensions';
import 'allink-core-static/js/modules/contact-form';



/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

Custom Scripts

*/

import './modules/default-modal';
import './modules/infobox';
import './modules/events-infobox';
import './modules/accordion';
import './modules/ajax-load-items';
import './modules/header';
import './modules/map';
import './modules/navigation';
import './modules/onscreen';
import './modules/parallax';
import './modules/swiper';
import './modules/to-the-top';
import './modules/footer';
import './modules/smooth-scroll';
import './modules/pagination';
import './modules/print-this';
import './modules/infobox';



// WEBPACK FOOTER //
// ./static/js/app.js